var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box box-primary color-palette-box mb-0"},[_c('VueApexCharts',{ref:"apexcharts",attrs:{"type":"line","height":"450px","options":_vm.options,"series":_vm.formatData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }